"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.saveConfigurationApi = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _axios = _interopRequireDefault(require("axios"));
var _filter = _interopRequireDefault(require("lodash/filter"));
var _settings = require("../settings");
var _camelCase = _interopRequireDefault(require("../utils/camelCase"));
var _filterSelections = _interopRequireDefault(require("../utils/filterSelections"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var getSelections = function getSelections(choices, options) {
  return (0, _filter["default"])(choices, function (choice) {
    return (0, _filterSelections["default"])(choice, options, choices);
  }).map(function (item) {
    var option = options[item.optionId];
    if (option === null) {
      throw new Error("Error building selections: can't find option with ID:".concat(item.optionId));
    }
    return {
      optionId: item.optionId,
      choiceId: item.id,
      choiceValue: item.value,
      optionType: option.optionType,
      optionTags: option.tags
    };
  });
};
var createConfiguration = function createConfiguration(options, choices, selections, productId) {
  var _getSettings = (0, _settings.getSettings)(),
    createConfigurationApi = _getSettings.createConfigurationApi,
    userId = _getSettings.userId,
    siteId = _getSettings.siteId,
    zipcode = _getSettings.zipcode;
  return typeof createConfigurationApi === 'string' ? (0, _axios["default"])({
    url: createConfigurationApi,
    data: {
      userId: userId,
      siteId: siteId,
      zipcode: zipcode.zipcode,
      productId: productId,
      selections: selections.map(function (selection) {
        return {
          optionId: selection.optionId,
          // TODO - make this not confusing
          choiceValue: selection.choiceId,
          choiceName: selection.choiceValue,
          optionType: selection.optionType,
          optionTags: selection.optionTags
        };
      })
    },
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    }
  }) : createConfigurationApi({
    options: options,
    choices: choices,
    selections: selections,
    productId: productId
  });
};
var editConfiguration = function editConfiguration(options, choices, selections) {
  var _getSettings2 = (0, _settings.getSettings)(),
    editConfigurationApi = _getSettings2.editConfigurationApi,
    configurationId = _getSettings2.configurationId,
    zipcode = _getSettings2.zipcode;
  return typeof editConfigurationApi === 'string' ? (0, _axios["default"])({
    url: editConfigurationApi,
    data: {
      configurationId: configurationId,
      zipcode: zipcode.zipcode,
      selections: selections.map(function (selection) {
        return _objectSpread(_objectSpread({}, selection), {}, {
          choicePrice: choices[selection.choiceId].price
        });
      })
    },
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    }
  }) : editConfigurationApi({
    options: options,
    choices: choices,
    selections: selections
  });
};

// eslint-disable-next-line import/prefer-default-export
var saveConfigurationApi = exports.saveConfigurationApi = function saveConfigurationApi(options, choices, productId) {
  var selections = getSelections(choices, options);
  var api = (0, _settings.getSettings)().mode === 'edit' // getSettings().configurationId
  ? editConfiguration : createConfiguration;
  return api(options, choices, selections, productId).then(function (response) {
    return (0, _camelCase["default"])(response.data);
  });
};
//# sourceMappingURL=saveApi.js.map